import {
  DonutChartDataSchema,
  DonutSchema,
  ResalesProductsTotalsSchema,
  TrendSchema,
} from "./Resales.type";
import { color } from "@amcharts/amcharts5";
import { formatCurrency } from "@feature/quotations/quotation-draft/lib/format";
import {defaultDonutColors} from "@components/Charts/commons";

export const elaborateProgressChartData = (
  res: ResalesProductsTotalsSchema
) => {
  const { quotation_approved, quotation_waiting, not_quoted } = res;
  let data = [];
  let from = 0;

  if (quotation_approved.value > 0) {
    data.push({
      category: "",
      from: 0,
      to: quotation_approved.percentage,
      income: quotation_approved.value,
      name: "Preventivato - accettato",
      columnSettings: {
        fill: color("#AECDAF"),
      },
    });
    from = quotation_approved.percentage;
  }
  if (quotation_waiting.value > 0) {
    data.push({
      category: "",
      from: from,
      to: from + quotation_waiting.percentage,
      income: quotation_waiting.value,
      name: "Preventivato - in attesa",
      columnSettings: {
        fill: color("#E4824C"),
      },
    });
    from += quotation_waiting.percentage;
  }
  if (not_quoted.value > 0) {
    data.push({
      category: "",
      from: from,
      to: from + not_quoted.percentage,
      income: not_quoted.value,
      name: "Non preventivato",
      columnSettings: {
        fill: color("#7F95A1"),
      },
    });
    from += not_quoted.percentage;
  }

  function parseIntToFixed(value: number) {
    return parseFloat(value.toFixed(2));
  }

  function getElement(el: any) {
    return {
      category: el.category || "",
      from: el.from,
      to: el.to,
      name: `${parseIntToFixed(el.to - el.from)}% ${el.name} - ${formatCurrency(
        el.income
      )}`,
      columnSettings: el.columnSettings,
    };
  }

  data = data.map((el) => getElement(el));
  return data;
};

export const elaborateTrendAndDonutChartData = (
  formattedMessage: any,
  trend: TrendSchema[],
  donut: DonutSchema[]
) => {
  const translationMap: { [key: string]: string } = {
    quotation_approved: formattedMessage({
      id: "quotation_approved",
      defaultMessage: "Preventivato - accettato",
    }),
    quotation_waiting: formattedMessage({
      id: "quotation_waiting",
      defaultMessage: "Preventivato - in attesa",
    }),
    not_quoted: formattedMessage({
      id: "not_quoted",
      defaultMessage: "Non preventivato",
    }),
    potential: formattedMessage({
      id: "potential",
      defaultMessage: "Potenziale",
    }),
    Others: formattedMessage({
      id: "Others",
      defaultMessage: "Altri",
    }),
  };
  let data = [];
  let trendMap: any = {};
  let series: Set<string> = new Set<string>();

  trend.forEach((el: any) => {
    // Costruisco un'array con i nomi dei prodotti che saranno le serie del grafo
    if (el.description in translationMap) {
      el.description = translationMap[el.description];
    }
    series.add(el.description);
    // Costruisco una mappa per creare i dati
    if (!trendMap[el.dat_month]) {
      trendMap[el.dat_month] = [
        {
          month: el.dat_month,
          [el.description]: el.value,
        },
      ];
    } else {
      trendMap[el.dat_month].push({
        month: el.dat_month,
        [el.description]: el.value,
      });
    }
  });
  for (let key in trendMap) {
    let el = trendMap[key];
    let obj = {};
    el.forEach((product: any) => {
      obj = { ...obj, ...product };
    });
    data.push(obj);
  }
  const trendData = data;
  const donutData:DonutChartDataSchema[] = [];
  const colorMap: {[index: string]:string} = {}
  // Donut chart
  donut.forEach((el: any, index ) => {
    const d = el.description in translationMap
          ? translationMap[el.description]
          : el.description
    donutData.push({
      category: d,
      value: el.value,
      ...(el.quantity?{
        quantityInfo:`${el.quantity.toFixed(2) || ''} ${el.quantity_uom || ''}`
      }:{}),
    })
    colorMap[d] = defaultDonutColors[index]
  });

  return {
    trendData, donutData, series: Array.from(series).map(
      (s, index) => {
        const color = colorMap[s] || defaultDonutColors[defaultDonutColors.length - (index+1)]
        return {
          name: s,
          color: color
        }
      }
    )
  };
};
